import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMetaInfo from 'vue-meta-info'
import Home from '../views/Home.vue'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)
Vue.use(VueMetaInfo)

const routes = [
	{
		path: '/',
		name: 'layout',
		component: Layout,
		redirect: {
			path: '/Home'
		},
		meta: { title: 'LOOPSHOP' },

		children: [
			{
				path: '/',
				name: 'Home',
				component: Home,
				meta: {
					title: 'LOOPSHOP',
				}
			},
			{
				path: '/about-us',
				name: 'about-us',

				meta: {

					title: '關於LOOPSHOP',
					metaTags: [
						{
							name: 'description',
							content: 'The home page of our example app.'
						},
						{
							property: 'og:description',
							content: 'The home page of our example app.'
						}
					]

				},
				component: () => import('../views/aboutUs.vue')
			},
			{
				path: '/plan',
				name: 'plan',
				meta: { title: '方案收費' },
				component: () => import('../views/plan/index.vue') //价格
			},		
			{
				path: '/jump',
				name: 'jump',
				meta: { title: 'jump' },
				component: () => import('../views/jump/index.vue') //价格
			},
			{
				path: '/blog',
				name: 'blog',
				meta: { title: '電商教室' },
				component: () => import('../views/news/commerceClassroom.vue') //新闻
			},
			{
				path: '/commerceClassroomList',
				name: 'commerceClassroomList',
				meta: { title: '電商教室' },
				component: () => import('../views/news/commerceClassroomList.vue')
			},
			{
				path: '/newsDetail',
				name: 'newsDetail',
				meta: { title: '詳情' },
				component: () => import('../views/news/newsDetail.vue') //新闻详情
			},
			{
				path: '/case-studies',
				name: 'case-studies',
				meta: { title: '客户案例' },
				component: () => import('../views/custom/case.vue')//客戶案例
			},
			{
				path: '/seminar',
				name: 'seminar',
				meta: { title: '開店講座' },
				component: () => import('../views/seminar/speech.vue')//開店講座
			},
			{
				path: '/consultation',
				name: 'consultation',
				meta: { title: '開店諮詢' },
				component: () => import('../views/consulting/advice.vue')//開店諮詢
			},
			{
				path: '/resources',
				name: 'Resources',
				meta: { title: '新手教學' },
				component: () => import('../views/openShop/resources.vue')//开店资源
			},
			{
				path: '/start',
				name: 'start',
				meta: { title: '開店支援' },
				component: () => import('../views/problemSummary/index.vue')
			},
			{
				path: '/faq',
				name: 'faq',
				meta: { title: '常見問題' },
				component: () => import('../views/openShop/common.vue')//常见问题
			},
			{
				path: '/privacy',
				name: 'privacy',
				meta: { title: '詳情' },
				component: () => import('../views/default/index.vue')//隐私
			},
			{
				path: '/terms',
				name: 'terms',
				meta: { title: '詳情' },
				component: () => import('../views/terms/index.vue')//条款
			},


		]
	},
	{
		path: '/register',
		name: 'register',
		meta: { title: 'LOOPSHOP註冊' },
		component: () => import('../views/create/register.vue')
	},
	{
		path: '/code',
		name: 'Code',
		meta: { title: '驗證碼' },
		component: () => import('../views/create/code.vue')
	},
	{
		path: '/selectionCriteria',
		name: 'SelectionCriteria',
		meta: { title: 'QA' },
		component: () => import('../views/create/selectionCriteria.vue')
	},
	{
		path: '/resett',
		name: 'Resett',
		meta: { title: '重置密碼' },
		component: () => import('../views/create/resett.vue')//重置密碼
	},
	{
		path: '/land',
		name: 'Land',
		meta: { title: '登錄' },
		component: () => import('../views/create/land.vue')//登錄
	}
]



const router = new VueRouter({
	mode: 'history',
	routes,
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title || 'LOOPSHOP'
	window.scrollTo(0, 0); // 将滚动位置设置为顶部
	next();
})


export default router
